import { useTranslations } from '@vocab/react';
import { Box, Button, Dialog, Inline, Stack, Text } from 'braid-design-system';

import translations from '../AvatarContainer/.vocab';

interface DeleteAvatarDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

export const DeleteAvatarDialog = ({
  open,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteAvatarDialogProps) => {
  const { t } = useTranslations(translations);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('Delete photo?')}
      width="xsmall"
    >
      <Stack space="medium">
        <Text>{t('Your photo will be deleted')}</Text>
        <Box display="flex" justifyContent="flexEnd">
          <Inline space="small">
            <Button tone="critical" loading={isDeleting} onClick={onConfirm}>
              {t('Delete')}
            </Button>
            <Button variant="transparent" onClick={onClose}>
              {t('Cancel')}
            </Button>
          </Inline>
        </Box>
      </Stack>
    </Dialog>
  );
};
